import _ from 'lodash'
import { noop } from 'lodash/fp'
import { createField, createSectionCreator } from './utils'
import {
  searchLuckyNumberOptions,
  setUsedLuckyNumberModal,
  setAutoAssignLuckyNumber,
  setConfirmLuckyNumberModal,
  setAutoAssignFailedModal,
  submitSelectedLuckyNumber,
} from 'e-submission/apps/actions'

const luckyNumberFields = (app, id) => {
  return [
    createField(`${id}.digits`, [
      {
        id: `${id}.digits`,
        c: 'LuckyNumberInput',
        required: false,
        p: {
          mergeState: (state, app, { dispatch = noop } = {}) => {
            return {
              searchLuckyNumberOptions: () => dispatch(searchLuckyNumberOptions()),
              setAutoAssignLuckyNumber: (val) => dispatch(setAutoAssignLuckyNumber(val)),
              setConfirmLuckyNumberModal: (val) => dispatch(setConfirmLuckyNumberModal(val)),
              setAutoAssignFailedModal: (val) => dispatch(setAutoAssignFailedModal(val)),
              submitSelectedLuckyNumber: () => dispatch(submitSelectedLuckyNumber()),
            }
          },
        },
      },
    ]),
    createField(`${id}.selected`, [
      {
        id: `${id}.selected`,
        c: 'LuckyNumberRadioGroup',
        required: false,
        p: {
          mergeState: (state, app, { dispatch = noop } = {}) => {
            return {
              setUsedLuckyNumberModal: (val) => dispatch(setUsedLuckyNumberModal(val)),
            }
          },
        },
      },
    ]),
  ]
}
export default createSectionCreator(luckyNumberFields)
